/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { OverviewUrgencyItem } from 'dashboard/types';

export function useOverviewUrgency(queryParams: string) {
  return useQuery<OverviewUrgencyItem[]>({
    queryKey: [APIKey.OVERVIEW_URGENCY, queryParams],
    queryFn: () => baseFetcher(`${apiRoutes.overviewUrgency()}?${queryParams}`),
  });
}
